import { Component, Input, inject } from '@angular/core';
import { StudentInfo } from '../../lib';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-student-list',
  templateUrl: './student-list.component.html'
})
export class StudentListComponent {
	toastService = inject(ToastService);
  @Input() students: StudentInfo[] | undefined;
}
